console.log('All obfuscated', document.querySelectorAll('[data-obf]').length);

if (document.querySelectorAll('[data-obf]').length > 0) {
  const obfuscatedLinks = document.querySelectorAll('[data-obf]');

  obfuscatedLinks.forEach((el) => {
    el.addEventListener('click', () => {
      console.log('el.dataset.blank', el.dataset.blank);
      if (el.dataset.blank !== undefined) window.open(toDecode(el.dataset.obf), '_blank');
      else window.location.href = toDecode(el.dataset.obf);
      //decodeAndOpenUrl(el.dataset.obfuscatedLink);
    });
  });

  window.addEventListener('load', () => {
    obfuscatedLinks.forEach((el) => {
      el.dataset.obf = toEncode(el.getAttribute('data-obf'));
    });
  });

  function toEncode(string) {
    return window.btoa(encodeURIComponent(string));
  }

  function toDecode(string) {
    return decodeURIComponent(window.atob(string));
  }

  function decodeAndOpenUrl(string) {
    //window.open(toDecode(string), '_blank');
  }
}

/*
https://www.loom.com/share/47bb1acde5f6478088c7d55f1dc41c7c
https://tropheewiki.notion.site/Obfuscation-SEO-Pourquoi-et-Comment-Cacher-Ses-Liens-5c1e24e20fa84aa3b0a33f058c014a17
https://www.youtube.com/watch?v=GTtETYSthf0
*/

/*

// Écouteur d'événements délégués
document.addEventListener("pointerup", (event) => {
  // On retire les éléments 'document' et 'window' du chemin de l'événement
  let obfuscatedPath = event.composedPath().slice(0, -2);

  let obfuscatedLink = obfuscatedPath.find((element) =>
    element.hasAttribute("data-obf")
  );

  if (typeof obfuscatedLink !== "object") return;

  obfuscatedLinkHandler(event, obfuscatedLink);
});

// Gestion des liens obfusqués
const obfuscatedLinkHandler = (event, element) => {
  let linkTarget = element.dataset.obf;
  let newTab = element.dataset.newTab !== undefined || event.button === 1;

  if (newTab) window.open(linkTarget, "_blank");
  else window.location.href = linkTarget;
};

<span data-obf="<https://virgil.dubois.fr>">Mentions légales</span>
*/
